import { ProgressBar, Row, Col } from 'react-bootstrap';
// eslint-disable-next-line no-unused-vars
import opaqueStar from 'assets/img/opaqueStar.png';
import './style.scss';
import { useWindowSize } from 'hooks';

const escala = ['Regular','Malo', 'Promedio', 'Suficiente','Bueno','Excelente'];

const ProgressBarContainerReview = ({ rating = 0, average = 1 }) => {
  // eslint-disable-next-line no-unused-vars
  const DATA_STAR = Array.from({ length: rating }, () => ({
    id: Math.random(),
  }));

  const [,{isMobile}] = useWindowSize()

  let progressVariant = '';

  if (escala[rating] === 'Excelente') {
    progressVariant = 'success';
  } else if (escala[rating] === 'Bueno') {
    progressVariant = 'lightgreen';
  } else if (escala[rating] === 'Suficiente') {
    progressVariant = 'warning';
  } else if (escala[rating] === 'Promedio') {
    progressVariant = 'info';
  } else if (escala[rating] === 'Malo') {
    progressVariant = 'danger';
  }

  return (
    <article className="">
      <Row className="">
        {
          !isMobile ? (
            <Col >
              <div className="flex-column">
                <p className="text-right">{escala[rating]}</p>
              </div>
            </Col>
          ) : (
            <div className="px-3 text-rating">
              <p>{escala[rating]}</p>
            </div>
          )
        }
        <Col className="px-3 px-md-3">
          <ProgressBar now={average} variant={progressVariant} />
        </Col>
        {/*<p className="flex-column ProgressBarReviews__text2">{average}%</p>*/}
      </Row>
    </article>
  );
};
export default ProgressBarContainerReview;
